export const isEmptyValue = (valor) => valor === null || valor === undefined || valor === 'None';

/**
 * Limpia "Pk: 7 | Descripción: PROPIEDAD PRIVADA"
 * - Si trae "descripcion: xxx" devuelve solo xxx
 */
export const cleanPkString = (valor) => {
  if (typeof valor !== 'string') return valor;
  const matchDesc = valor.match(/Descripción:\s*(.+)$/i);
  if (matchDesc) return matchDesc[1].trim();
  if (valor.includes('|')) {
    const last = valor.split('|').pop().trim();
    return last.replace(/^[^:]*:\s*/, '').trim();
  }
  return valor;
};

/**
 * formatea un valor buscando por id dentro de un catálogo y devolviendo
 * el primer campo existente en "campos"
 */
export const formatByCatalog = (valor, catalogo, campos = ['descripcion', 'nombre', 'clave']) => {
  if (!valor && valor !== 0) return '—';
  const limpio = cleanPkString(valor);
  const num = Number(limpio);
  if (!Number.isNaN(num)) {
    const found = (catalogo || []).find((x) => String(x.id) === String(num));
    if (found) {
      // eslint-disable-next-line no-restricted-syntax
      for (const c of campos) {
        if (found[c]) return found[c];
      }
      return num;
    }
  }
  return limpio;
};

/**
 * Convierte a numero decimal
 */
export const toNumber = (v) => {
  if (v === null || v === undefined) return null;
  const s = String(v).trim();
  if (!s || s.toLowerCase() === 'none') return null;
  const n = Number(s.replace(/,/g, ''));
  return Number.isFinite(n) ? n : null;
};

/**
 * Muestra decimales con dos ddgitos si el valor inicial no tiene punto,
 * lo fuerza a .00
 */
export const formatDecimalForDisplay = (value, { isAnterior = false } = {}) => {
  const n = toNumber(value);
  if (n === null) return '—';
  if (isAnterior) return n.toFixed(2);
  const raw = String(value);
  if (!raw.includes('.')) return n.toFixed(2);
  return raw;
};
